class ScrollButton extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');

    this.button.addEventListener('click', this.handleClick);

    setTimeout(() => {
      this.classList.add('visible');
      this.cookieNotice = document.querySelector('#cookie-notice');
      if (this.cookieNotice) {
        this.cookieNotice.classList.add('visible');
      }
    }, 2000);

    window.addEventListener('scroll', () => {
      this.classList.remove('visible');
      this.cookieNotice = document.querySelector('#cookie-notice');
      if (this.cookieNotice) {
        this.cookieNotice.classList.add('visible');
      }

      if (window.scrollY === 0) {
        setTimeout(() => {
          if (window.scrollY === 0) {
            this.classList.add('visible');
          }
        }, 2000);
      }
    });
  }

  handleClick = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: 'smooth',
    });
  }

}

customElements.define('scroll-button', ScrollButton);